<template>
	<v-container fluid class="blue-grey lighten-5">
		<v-container grid-list-lg>
			<v-layout column wrap>
				<v-overlay :absolute="overlay.absolute" :opacity="overlay.opacity" :value="overlay.status" :z-index="overlay.zIndex"> </v-overlay>
				<h1 class="mt-3 black--text font-weight-bold">سفارش خرید نرم افزار</h1>
				<v-divider></v-divider>
				<v-flex class="subheading mt-2 grey--text">برای ثبت سفارش خرید نرم افزار، فرم زیر را برای ما ارسال کنید،کارشناسان فروش با شما تماس خواهند گرفت</v-flex>
				<v-flex class="subheading mt-2 grey--text text-sm-left">از حسن انتخاب شما متشکریم</v-flex>

				<v-form ref="form" v-model="valid" lazy-validation>
					<v-container>
						<!-- Notification -->
						<notification v-model="successAlert" class="mb-3" color="success" dismissible>
							<strong>{{ successMessage }}</strong>
						</notification>
						<notification v-model="errorAlert" class="mb-3" color="error" dismissible>
							<strong>{{ errorMessage }}</strong>
						</notification>

						<v-layout column wrap>
							<v-flex xs12 md4>
								<v-text-field v-model="fullname" :rules="nameRules" :counter="200" label="نام و نام خانوادگی" required></v-text-field>
							</v-flex>
							<v-flex xs12 md4>
								<v-text-field v-model="mobile" :rules="numberRules" :counter="11" label="موبایل" required></v-text-field>
							</v-flex>
							<v-flex xs12 md4>
								<v-text-field v-model="email" :rules="emailRules" :counter="50" label="ایمیل"></v-text-field>
							</v-flex>
							<v-flex xs12 md4>
								<v-text-field v-model="senf" :rules="senfRules" :counter="100" label="نوع صنف" required></v-text-field>
							</v-flex>
							<v-flex xs12 md4>
								<!-- <v-select id="product" v-model="product" :items="products" :item-text="(item) => `${item.baseName}   ${item.name}`" item-value="id" return-object filled light label="نوع محصول" v-on:change="toggle"></v-select> -->
								<v-select v-model="product" :items="products" :item-text="(item) => `${item.baseName}   ${item.name}`" item-value="id" return-object filled light label="نوع محصول"></v-select>
							</v-flex>
							<!-- <v-flex xs12 md4 v-if="product.id">
								<v-label>لطفا ماژولهای مورد نیاز را انتخاب نمایید:</v-label>
							</v-flex> -->

							<!-- <v-radio-group v-model="baseKit" row>
								<v-radio v-for="(item, index) in options" :key="index" :value="item.code" :label="item.name" row></v-radio>
							</v-radio-group> -->

							<v-row class="mx-2" wrap v-if="product.id">
								<v-row>
									<v-col cols="12"><v-label>لطفا ماژولهای مورد نیاز را انتخاب نمایید:</v-label></v-col>
								</v-row>
								<v-row>
									<!-- <v-col xs12 md4 v-for="(item, index) in options" :key="index"> -->
									<v-col cols="12" sm="6" md="4" v-for="(item, index) in options" :key="index">
										<v-checkbox v-model="modules" :value="item.id" :label="item.name"></v-checkbox>
									</v-col>
								</v-row>
							</v-row>
						</v-layout>
						<v-btn @click="submitData" large color="black" dark v-if="product.id">ثبت سفارش</v-btn>
					</v-container>
				</v-form>
			</v-layout>
		</v-container>
	</v-container>
</template>

<script>
	import Notification from "@/components/Notification";
	export default {
		components: {
			Notification,
		},
		computed: {
			products() {
				return this.$store.state.products;
			},
		},
		watch: {
			product(item) {
				this.modules = [];
				if (item.type == "plus") {
					this.options = this.$store.state.plusKits;
				} else if (item.type == "12") {
					this.options = this.$store.state.v12Kits;
				}
			},
		},
		data() {
			return {
				overlay: { absolute: false, opacity: 0.46, status: false, zIndex: 5 },
				response: "",
				fields: [],
				count: 0,
				arr: [],
				valid: false,
				fullname: "",
				senf: "",
				email: "",
				mobile: "",
				// snackbar: false,
				// snackbarMessage: "",
				errorMessage: "",
				errorAlert: false,
				successAlert: false,
				successMessage: "",
				product: {},
				options: [],
				modules: [],
				compSwitcher: [],
				nameRules: [(v) => !!v || "وارد کردن نام الزامی است", (v) => v.length <= 200 || "حداکثر 200 حرف باشد"],
				emailRules: [(v) => !!v || "وارد کردن ایمیل الزامی است", (v) => /.+@.+/.test(v) || "ایمیل وارد شده صحیح نمی باشد", (v) => v.length <= 50 || "حداکثر 50 حرف باشد"],
				senfRules: [(v) => !!v || "وارد کردن صنف الزامی است", (v) => v.length <= 100 || "حداکثر 100 حرف باشد"],
				numberRules: [(v) => !!v || "وارد کردن شماره موبایل  الزامی است", (v) => v.length <= 11 || "حداکثر 11 حرف باشد", (v) => /^\d*$/.test(v) || "شماره وارد شده صحیح نمی باشد"],
			};
		},
		methods: {
			// toggle() {
			// const product = this.product;
			// this.modules = [];
			// if (product.type == "plus") {
			// 	this.options = this.$store.state.plusKits;
			// } else if (product.type == "12") {
			// 	this.options = this.$store.state.v12Kits;
			// }
			// },
			async submitData() {
				this.overlay.status = true;
				// console.info(this.product.id, this.modules);
				if (this.$refs.form.validate() && this.product.id) {
					let kits = "";
					kits += this.product.id;
					for (var i = 0; i <= this.modules.length - 1; i++) {
						kits += `,${this.modules[i]}`;
					}
					const data = {
						FullName: this.fullname,
						Mobile: this.mobile,
						Email: this.email,
						BusinessType: this.senf,
						ProductId: this.product.groupId,
						Kits: kits,
					};

					const response = await this.$store.dispatch("insertBuyReq", { data });
					console.info(response);
					if (response) {
						const status = response.status;
						if (status == "200") {
							this.successAlert = true;
							this.successMessage = "سفارش شما با موفقیت ثبت گردید.";
							this.product = {};
							this.valid = false;
							this.fullname = "";
							this.senf = "";
							this.email = "";
							this.mobile = "";
						} else if (status == "400") {
							this.errorAlert = true;
							this.errorMessage = "به هنگام ثبت سفارش خطایی (ورودی های نادرست) رخ داد. لطفا مجددا سعی کنید.";
						} else {
							this.errorAlert = true;
							this.errorMessage = response.error;
						}
					} else {
						this.errorAlert = true;
						this.errorMessage = "به هنگام ثبت سفارش خطایی رخ داد. لطفا مجددا سعی کنید.";
					}
				}
				this.overlay.status = false;
			},
		},
	};
</script>

<style>
	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.25s;
	}
</style>
